import { Link } from "react-router-dom";

export default function PageHeader({ title, subtitle, crumb }) {
  return (
    <section className="relative bg-brand-dark text-white overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_30%_20%,#D4AF37_0%,transparent_45%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="text-xs uppercase tracking-[0.25em] text-brand-gold flex items-center gap-2">
          <Link to="/" className="hover:text-white">Home</Link>
          <span>›</span>
          <span className="text-white/80">{crumb}</span>
        </div>
        <h1 className="display-serif mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-white/80 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
